import {useRouter} from 'next/router';

export const useLocale = () => {
  const router = useRouter()
  const {locale} = router

  return locale
}
